//
// locale_ja.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ja.json';
import localeData from "react-intl/locale-data/ja.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_ja.js